import { GrantEnum } from "view360Card/models/GrantEnum";

export class GrantsFromResponse {
    constructor(private grantsFromResponse: string[] | undefined) {}

    grants(): GrantEnum[] {
        const result: GrantEnum[] = [];
        this.grantsFromResponse?.includes("GRANT_TASK") && result.push(GrantEnum.Task);
        this.grantsFromResponse?.includes("GRANT_POWER_BI") && result.push(GrantEnum.PowerBi);
        this.grantsFromResponse?.includes("GRANT_REPORT_RANKING") && result.push(GrantEnum.ReportRanking);
        this.grantsFromResponse?.includes("GRANT_REPORT_SCORE_CARD") && result.push(GrantEnum.ReportScoreCard);
        this.grantsFromResponse?.includes("GRANT_V360") && result.push(GrantEnum.V360);
        this.grantsFromResponse?.includes("GRANT_SHAREPOINT") && result.push(GrantEnum.Sharepoint);
        this.grantsFromResponse?.includes("GRANT_USER_PROFILE") && result.push(GrantEnum.UserProfile);
        this.grantsFromResponse?.includes("GRANT_V360_EMPLOYEES") && result.push(GrantEnum.V360Employees);
        this.grantsFromResponse?.includes("GRANT_NOTES") && result.push(GrantEnum.V360Notes);
        this.grantsFromResponse?.includes("GRANT_V360_DATA_EHZ") && result.push(GrantEnum.V360SalesDataEhz);
        this.grantsFromResponse?.includes("GRANT_V360_DATA_EHM") && result.push(GrantEnum.V360SalesDataEhm);
        this.grantsFromResponse?.includes("GRANT_DAILY_SALES") && result.push(GrantEnum.V360SalesDaily);
        this.grantsFromResponse?.includes("GRANT_NOTES_MODULE") && result.push(GrantEnum.GlobalNotes);
        return result;
    }
}
